import type { AxiosResponse } from 'axios';

import axios from 'Services/axios';

export const sendPositiveFeedback = async (enquiryId: number): Promise<AxiosResponse> =>
	axios.post(`/api/service-history/${enquiryId}/feedback`, {
		isPositive: true,
	});

export const sendNegativeFeedback = async (enquiryId: number, feedback: string): Promise<AxiosResponse> =>
	axios.post(`/api/service-history/${enquiryId}/feedback`, {
		feedback,
		isPositive: false,
	});
